import { StockVisual } from '../../components/StockVisual';
import { TweakwiseFilterSearch } from '../../components/TweakwiseFilterSearch';

class CatalogIndex {
    init() {
        const stockVisual = new StockVisual();

        if (useGtmEcommerceEvents) {
            document.dispatchEvent(new CustomEvent('GTMViewItemList'));

            let items = document.querySelectorAll('.item');

            if (items) {
                items.forEach(item => {
                    item.addEventListener('click', Event => {
                        document.dispatchEvent(new CustomEvent('GTMSelectItem',  {
                            detail: {
                                itemElement: item,
                                itemId: item.dataset.modelNo,
                                itemName: item.querySelector('.info-block h5 a') ? item.querySelector('.info-block h5 a').innerHTML : '',
                                colorElements: item.querySelectorAll('.item-colors .color'),
                                itemPrice: item.querySelector('.price span') ? item.querySelector('.price span').innerHTML.trim() : '',
                            }
                        }));
                    });
                });
            }
        }

        if (useTweakwiseEventTag) {
            document.dispatchEvent(new CustomEvent('TweakwisePageImpression'));

            const searchword = document.querySelector('#tweakwise_searchfield').getAttribute('value');

            if (searchword) {
                document.dispatchEvent(new CustomEvent('TweakwiseSearch', {
                    detail: { searchword: searchword }
                }));
            }

            let items = document.querySelectorAll('.item');

            if (items) {
                items.forEach(item => {
                    item.addEventListener('click', Event => {
                        document.dispatchEvent(new CustomEvent('TweakwiseClickProduct',  {
                            detail: {
                                product: item.dataset.tweakwiseItemId,
                            }
                        }));
                    });
                });
            }
        }

        stockVisual.init();
        this.quickOrderModal();
        this.tweakwiseFilterSearch();
    }

    quickOrderModal() {
        document.addEventListener('click', async (e) => {
            if (e.target.matches('*[data-role=quickOrder]')) {
                const el = e.target;
              
                loadOrdermatrixContent(el.dataset.modelNo);
                openQuickorderModal();
            }
          });
    }

    tweakwiseFilterSearch() {
        const tweakwiseFilterSearchFields = document.querySelectorAll('input[name^=tweakwise_searchfield_]');
        if (tweakwiseFilterSearchFields.length > 0) {
            tweakwiseFilterSearchFields.forEach(input => {
                new TweakwiseFilterSearch(`input[name=${input.name}]`);
            });
        }
    }
}

addEventListener('DOMContentLoaded', e => {
    const catalogIndex = new CatalogIndex();

    catalogIndex.init();
});
